import { routes } from "configs";
import { TeacherDefaultHomeRouteType } from "types";

const getRoute = (
  teacherDefaultHomeRoute: TeacherDefaultHomeRouteType,
): string => {
  // key values as constants
  const routesMap = {
    home: routes.home,
    scopes: routes.scopes,
    standards: routes.rootStandards,
    lesson_planner: routes.planner,
    teacher_sections: routes.students,
    teacher_assessments: routes.teacherAssessments,
    bitsbox: routes.bitsbox,
  };

  return routesMap[teacherDefaultHomeRoute];
};

export default getRoute;
